import * as Sentry from '@sentry/react';
import indexReducer from '../reducers/index';
import { localEnv } from './sentry';
import {
  PreloadedStateShapeFromReducersMapObject,
  StoreEnhancer,
  configureStore,
} from '@reduxjs/toolkit';
import { rootApi } from '@components/rootApi';

export const configuredStore = (
  preloadedState?: PreloadedStateShapeFromReducersMapObject<typeof indexReducer>
) => {
  // createReduxEnhancer returns any in the library itself
  const sentryEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: () => ({ msg: 'Skipping state data' }),
  }) as StoreEnhancer;
  const shouldLoadSentryEnhancer =
    !localEnv() || process.env.ENABLE_LOCAL_SENTRY_JS;
  const enhancers = shouldLoadSentryEnhancer ? [sentryEnhancer] : [];

  return configureStore({
    reducer: indexReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        // TODO: Right now these throw errors when enabled. Clean up redux store usage and turn these back on.
        serializableCheck: false,
        immutableCheck: false,
        // eslint-disable-next-line unicorn/prefer-spread
      }).concat(rootApi.middleware),
    // eslint-disable-next-line unicorn/prefer-spread
    enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(enhancers),
    // devTools: localEnv(), // TODO: This was enabled outside dev, but do we want to change it?
    preloadedState,
  });
};

const baseStore = configuredStore();

export type RootState = ReturnType<typeof baseStore.getState>;
export type AppDispatch = typeof baseStore.dispatch;

export default baseStore;
